import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SignaturePadComponent } from 'src/app/shared/signature-pad/signature-pad.component';

export interface HormigonFirmaPadModalData {
  initialValue?: string;
}

@Component({
  selector: 'app-hormigon-firma-pad-modal',
  templateUrl: './hormigon-firma-pad-modal.component.html',
  styleUrls: [
    './hormigon-firma-digital-page.component.css',
    './hormigon-firma-pad-modal.component.css',
  ],
  standalone: false,
})
export class HormigonFirmaPadModalComponent {
  @ViewChild(SignaturePadComponent) pad?: SignaturePadComponent;

  canSave = false;

  constructor(
    private readonly dialogRef: MatDialogRef<HormigonFirmaPadModalComponent, string>,
    @Inject(MAT_DIALOG_DATA) readonly data: HormigonFirmaPadModalData
  ) {
    this.canSave = !!this.data?.initialValue;
  }

  onValueChange(value: string): void {
    this.canSave = !!value;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  save(): void {
    const value = this.pad?.toDataUrl() || this.data?.initialValue || '';
    if (!value) return;
    this.dialogRef.close(value);
  }
}
